// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Parent {\n  width: 18rem;\n  height: 100%;\n  position: absolute;\n  left: 22rem;\n  top: 0px;\n  pointer-events: none; }\n\n.Cluster {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  height: 50%; }\n", ""]);
// Exports
module.exports = exports;
